import { useRef, useState, useEffect } from "react";
import "../styles/ecosystem.scss";

const JOURNEY_STEPS = [
  {
    id: 1,
    title: "Capture Every Unit of Energy",
    description: "Precision smart meters track real-time consumption",
    image: "/image/1-captureEnergy1.gif"
  },
  {
    id: 2,
    title: "Convert Data into Insights",
    description: "AI analyzes patterns and predicts demand",
    image: "/image/2captureEnergy2.gif"
  },
  {
    id: 3,
    title: "Optimize Usage & Procurement",
    description: "Intelligent decisions reduce cost and improve efficiency, HVAC, BESS, etc.",
    image: "/image/3captureEnergy3.gif"
  },
  {
    id: 4,
    title: "Drive Real Business Outcomes",
    description: "Lower costs. Higher reliability. Smarter energy decisions.",
    image: "/image/4captureEnergy4.gif"
  }
];

function EcosystemSection() {
  const [activeStep, setActiveStep] = useState(0);
  const journeyCardsRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      if (!journeyCardsRef.current) return;

      // Get all journey cards
      const cards = journeyCardsRef.current.querySelectorAll('.journey-card');

      // Find which card is in the viewport
      cards.forEach((card, index) => {
        const rect = card.getBoundingClientRect();
        const cardCenter = rect.top + rect.height / 2;
        const viewportCenter = window.innerHeight / 2;

        // If card center is closest to viewport center, make it active
        if (cardCenter >= viewportCenter - 100 && cardCenter <= viewportCenter + 100) {
          setActiveStep(index);
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="ecosystem">
      <div className="container">
        <h2 className="ecosystem-title">
          <span className="highlight">A Unified Energy</span> Intelligent Ecosystem
        </h2>

        <div className="ecosystem-content">
          <div className="journey-container">
            <div className="journey-header">
              The Journey of Every Energy Unit
            </div>
            <div className="journey-steps" ref={journeyCardsRef}>
              {JOURNEY_STEPS.map((step, index) => (
               <>
                <button
                  key={step.id}
                  className={`journey-card ${activeStep === index ? "active" : ""}`}
                  onClick={() => setActiveStep(index)}
                >
                  <h3 className="journey-card-title">{step.title}</h3>
                  <p className="journey-card-description">{step.description}</p>
                </button>
                <img src={step.image} alt={step.title} className="ecosystem-image-mob" width="100%" />
               </>
              ))}
            </div>
          </div>

          <div className="ecosystem-image-container">
            <img
              key={activeStep}
              src={JOURNEY_STEPS[activeStep].image}
              alt={JOURNEY_STEPS[activeStep].title}
              className="ecosystem-image"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default EcosystemSection;
